<template>
  <footer role="contentinfo" aria-label="Footer" class="footer">
    <div class="footer__custom">
      <!-- Mobile View -->
      <div class="footer__custom--mobile wrapper">
        <div style="margin: 2rem 0;">
          <BrandLogo
            :partnerLogo="partnerLogo"
            :partnerTitle="partnerTitle"
            :partnerTypeId="partnerTypeId"
          />
          <p>For any questions you can contact us, every day 7:00am - 20:00pm (UTC +02:00).</p>

          <div class="site-footer__custom_title">Contact Us</div>

          <div class="footer__custom__subsection">
            <a
              :href="'https://wa.me/phone=' + appInfo.cc_whatsapp"
              aria-label="Contact us via WhatsApp at +{{ appInfo.cc_whatsapp }}"
            >
              <img
                class="footer__custom__logo"
                style="margin-right: .3rem;"
                :src="brandedWhatsApp"
                alt=""
                aria-hidden="true"
              />
              +{{ appInfo.cc_whatsapp }} (chat only)
            </a>
          </div>

          <div class="footer__custom__subsection">
            <a :href="'tel:' + appInfo.cc_phonecall" aria-label="Call customer support at {{ appInfo.cc_phonecall }}">
              <img
                class="footer__custom__logo"
                style="margin-right: .3rem;"
                :src="brandedPhone"
                alt=""
                aria-hidden="true"
              />
              <span>{{ appInfo.cc_phonecall }}</span>
            </a>
          </div>

          <div class="footer__custom__subsection">
            <a
              :href="'mailto:' + (partnerEmail || appInfo.cc_email)"
              :aria-label="'Email customer support at ' + (partnerEmail || appInfo.cc_email)"
            >
              <img
                class="footer__custom__logo"
                style="margin-right: .3rem;"
                :src="brandedEmail"
                alt=""
                aria-hidden="true"
              />
              <span>{{ partnerEmail || appInfo.cc_email }}</span>
            </a>
          </div>
        </div>

        <div class="line"><hr aria-hidden="true" /></div>

        <div style="margin-top: 2rem;">
          <p style="display: flex; align-items: center;">
            Supported by
            <img
              class="footer__custom__logo"
              src="/logos/clio_logo.png"
              style="margin-left: .5rem; margin-right: .4rem;"
              alt="Clio Muse Tours logo"
            />
            Clio Muse Tours
          </p>
          <p class="footer__custom__copyright" aria-live="polite">
            © {{ new Date().getFullYear() }} Copyright | All rights reserved
          </p>
        </div>
      </div>

      <!-- Desktop View -->
      <div class="footer__custom--desktop wrapper">
        <div class="footer__custom__row" style="margin: 2rem 0;">
          <BrandLogo
            :partnerLogo="partnerLogo"
            :partnerTitle="partnerTitle"
            :partnerTypeId="partnerTypeId"

          />
        </div>

        <div class="footer__custom__row section--padding-top-short " aria-label="Contact information">
          <div class="footer__custom__column footer__custom__column-footer">
            <p>For any questions you can contact us, every day 7:00am - 20:00pm (UTC +02:00).</p>
          </div>

          <div class="footer__custom__column footer__custom__column-footer">
            <div
              class="site-footer__custom_title"
              style="margin: 0; margin-left: 6rem;"
              id="contact-us-title"
            >
              Contact Us
            </div>
          </div>

          <div class="footer__custom__column footer__custom__column-footer">
            <a
              :href="'https://wa.me/phone=' + appInfo.cc_whatsapp"
              aria-label="Contact us via WhatsApp at +{{ appInfo.cc_whatsapp }}"
            >
              <img
                class="footer__custom__logo"
                style="margin-right: .3rem;"
                :src="brandedWhatsApp"
                alt=""
                aria-hidden="true"
              />
              +{{ appInfo.cc_whatsapp }} (chat only)
            </a>
          </div>

          <div class="footer__custom__column footer__custom__column-footer">
            <a :href="'tel:' + appInfo.cc_phonecall" :aria-label="'Call customer support at ' + appInfo.cc_phonecall">
              <img
                class="footer__custom__logo"
                style="margin-right: .3rem;"
                :src="brandedPhone"
                alt=""
                aria-hidden="true"
              />
              <span>{{ appInfo.cc_phonecall }}</span>
            </a>
          </div>

          <div class="footer__custom__column footer__custom__column-footer">
            <a
              :href="'mailto:' + (partnerEmail || appInfo.cc_email)"
              :aria-label="'Email customer support at ' + (partnerEmail || appInfo.cc_email)"
            >
              <img
                class="footer__custom__logo"
                style="margin-right: .3rem;"
                :src="brandedEmail"
                alt=""
                aria-hidden="true"
              />
              <span>{{ partnerEmail || appInfo.cc_email }}</span>
            </a>
          </div>
        </div>

        <div class="line"><hr aria-hidden="true" /></div>

        <div class="footer__custom__row section--padding-top-short">
          <div class="footer__custom__column">
            <p style="display: flex; align-items: center;">
              Supported by
              <img
                class="footer__custom__logo"
                src="/logos/clio_logo.png"
                style="margin-left: .5rem; margin-right: .4rem;"
                alt="Clio Muse Tours logo"
              />
              Clio Muse Tours
            </p>
          </div>

          <div class="footer__custom__column" style="justify-content: flex-end;">
            <p class="footer__custom__copyright" aria-live="polite">
              © {{ new Date().getFullYear() }} Copyright | All rights reserved
            </p>
          </div>
        </div>
      </div>
      <div class="wrapper footer__custom__bottom" style="background-color: var(--main-color);">
        <br>
      </div>
    </div>
  </footer>
</template>

<script setup>
import BrandLogo from './BrandLogo.vue';
import info from '~/data/info.json';

// Define props
const props = defineProps({
  partnerLogo: {
    default: '',
    type: String
  },
  partnerTitle: {
    default: '',
    type: String
  },
  partnerEmail: {
    default: '',
    type: String
  },
  partnerTypeId: {
    default: null,
    type: [Number, null]
  }
});

// Reactive data
const appInfo = info;
const brandedWhatsApp = '/contact/branded/whatsapp.png';
const brandedPhone = '/contact/branded/phone.png';
const brandedEmail = '/contact/branded/email.png';
</script>